import React from 'react';
import EntityModal from '../common/EntityModal';
import CompanyForm from './CompanyForm';

const CompanyModal = ({ isOpen, onClose, company = null, onSubmit, loading = false }) => (
  <EntityModal
    isOpen={isOpen}
    onClose={onClose}
    entity={company}
    entityName="Company"
    FormComponent={CompanyForm}
    onSubmit={onSubmit}
    loading={loading}
    size="lg"
  />
);

export default CompanyModal;
